import {Action} from '@ngrx/store';

import {SueloCore} from './suelos.state';

export enum SuelosActionTypes {
  SUELOS_LOAD_REQUEST = '[SUELOS] Load Request',
  SUELOS_LOAD_FAILURE = '[SUELOS] Load Failure',
  SUELOS_LOAD_SUCCESS = '[SUELOS] Load Success'
}

// load

export class SuelosLoadRequestAction implements Action {
  readonly type = SuelosActionTypes.SUELOS_LOAD_REQUEST;
}

export class SuelosLoadFailureAction implements Action {
  readonly type = SuelosActionTypes.SUELOS_LOAD_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class SuelosLoadSuccessAction implements Action {
  readonly type = SuelosActionTypes.SUELOS_LOAD_SUCCESS;

  constructor(public payload: { items: SueloCore[] }) {
  }
}

// actions

export type SuelosActions =
  | SuelosLoadRequestAction
  | SuelosLoadFailureAction
  | SuelosLoadSuccessAction;
